import { render, staticRenderFns } from "./collectCreation.vue?vue&type=template&id=594be8b0&scoped=true"
import script from "./collectCreation.vue?vue&type=script&lang=js"
export * from "./collectCreation.vue?vue&type=script&lang=js"
import style0 from "./collectCreation.vue?vue&type=style&index=0&id=594be8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594be8b0",
  null
  
)

export default component.exports